import React from 'react'
import { Helmet } from 'react-helmet-async'
import { DocumentationLayout } from '../../layouts/Support'

const DocumentationPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Documentation</title>
      <meta name="description" content="Documentation page" />
    </Helmet>

    <DocumentationLayout />
  </React.Fragment>
)

export default DocumentationPage
